module.exports = __webpack_public_path__ + "static/media/map.65290817.png";